import { render, staticRenderFns } from "./TencentDefault.vue?vue&type=template&id=275a9931"
import script from "./TencentDefault.vue?vue&type=script&lang=js"
export * from "./TencentDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports